import React, { useEffect } from 'react';
import { vpStreaming } from '../vpPlayer/js/vpPlayerBundle.min.js';
import '../vpPlayer/css/theme.min.css';

function VoicePad({ voicePadStreamKey }) {
    useEffect(() => {
        new vpStreaming.player("myPlayer", { streamKey: voicePadStreamKey});
    }, [voicePadStreamKey]);

   return (<div><br/><div id="myPlayer"></div></div>);
}

export default VoicePad;